import { Component } from '@angular/core';

import { Toast, ToastrService, ToastPackage } from 'ngx-toastr';
import {
    animate,
    keyframes,
    state,
    style,
    transition,
    trigger
} from '@angular/animations';
import { Actions } from './interface/actions.interface';
import { IconComponent } from '../icon/icon.component';
import { TypoComponent } from '../typo/typo.component';
import { ButtonComponent } from '../../forms/components/button/button.component';
import { TranslateModule } from '@ngx-translate/core';

@Component({
    selector: '[epmax-toast]',
    imports: [IconComponent, TypoComponent, ButtonComponent, TranslateModule],
    templateUrl: './toastr.component.html',
    styleUrl: './toastr.component.scss',
    animations: [
        trigger('flyInOut', [
            state('inactive', style({
                opacity: 1,
            })),
            transition('inactive <=> active', animate('500ms ease-out', keyframes([
                style({
                    transform: 'translateX(340px)',
                    offset: 0,
                    opacity: 0,
                }),
                style({
                    offset: .7,
                    opacity: 1,
                    transform: 'translateX(-20px)'
                }),
                style({
                    offset: 1,
                    transform: 'translateX(0)',
                })
            ]))),
            transition('active => removed', animate('500ms ease-in', keyframes([
                style({
                    transform: 'translateX(-20px)',
                    opacity: 1,
                    offset: .2
                }),
                style({
                    opacity: 0,
                    transform: 'translateX(340px)',
                    offset: 1
                })
            ])))
        ]),
    ],
    preserveWhitespaces: false
})
export class ToastrComponent extends Toast {
    iconName: string = 'evicon-exclamation';
    iconColor: any = 'success';
    actions: Actions[] = [];
    override title!: string;

    constructor(protected override toastrService: ToastrService, public override toastPackage: ToastPackage) {
        super(toastrService, toastPackage);
        if (this.toastPackage.config.payload?.actions)
            this.actions = this.toastPackage.config.payload?.actions
        switch (this.toastPackage.toastType) {
            case 'toast-error':
                this.iconName = 'warning';
                this.iconColor = 'danger'
                this.options.toastClass = "toast-icon custom-toast-error"
                break;
            case 'toast-success':
                this.iconName = 'check_circle'
                this.iconColor = 'success'
                this.options.toastClass = 'custom-toast-success'
                break;
            case 'toast-info':
                this.iconName = 'info'
                this.iconColor = 'info'
                this.options.toastClass = 'custom-toast-info'
                break;
            case 'toast-warning':
                this.iconName = 'notification_important'
                this.iconColor = 'warning'
                this.options.toastClass = 'custom-toast-warning'
                break;
        }
    }


    getAutomationId(i: number) {
        if (i == 1) {
            return 'toastr-cancel-button'
        } else {
            return this.toastPackage.toastType + '-button'
        }
    }
}
